import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import {
	sigInAction,
	updateStatus,
	azureSignInAction,
	tenantAction,
	orgCurrentCycleAction,
	currentCycleStatus,
	isSupportUser,
	tenantActionOkr,
} from '../../../action/signin';
import SignIn from '../../../components/Guest/SignIn';
import { updateRoute, showLoader, updatePage, getCycleDetails } from '../../../action/common';
import { getOnboarding, updateOnboardingCount } from '../../../action/onboarding';
import { getEmployeePermission } from '../../../action/roles';

const mapStateToProps = (state) => {
	return {
		signInStatus: state.signReducer.signInStatus,
		pending: state.signReducer.pending,
		messageList: state.signReducer.messageList,
		entity: state.signReducer.entity,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			azureSignInAction,
			orgCurrentCycleAction,
			tenantAction,
			sigInAction,
			updateRoute,
			showLoader,
			updatePage,
			updateStatus,
			getCycleDetails,
			getOnboarding,
			updateOnboardingCount,
			getEmployeePermission,
			currentCycleStatus,
			isSupportUser,
			tenantActionOkr,
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SignIn));
